export const footerCSS = `

	.cfoot__info li a,
	.cfoot__links {
		color: #f5f5f5
	}
	.cfoot hidden-xs {
		width: 100%
	}
	.cfoot__links {
		background: #16355c
	}
	.cfoot__head {
		font-size: 16px;
		margin-bottom: 10px;
		font-weight: 600
	}
	.cfoot__container {
		display: table;
		width: 80%;
		margin: 0 auto;
		padding: 75px 0;
		font-size: 13px
	}
	.footer_block {
		display: table-cell;
		min-width: 100px;
		max-width: 226px
	}
	.footerLinks {
		display: flex;
		justify-content: space-between
	}
	.lowSeoContent {
		padding-right: 16%;
		padding-left: 16%
	}
	.lowSeoContent h1 {
		font-weight: 400;
		font-size: 36px
	}
`;
